import { supportAgentTreatmentZodSchema } from "@redotech/redo-model/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const startSupportAgentSplit = {
  name: "startSupportAgentSplit" as const,
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string(),
    treatments: z.array(
      z.object({
        name: z.string(),
        weight: z.number(),
        channel: supportAgentTreatmentZodSchema.shape.channel,
        supportAgentConfig:
          supportAgentTreatmentZodSchema.shape.supportAgentConfig,
      }),
    ),
  }),
  output: z.void(),
};
